import { FC, KeyboardEvent, Ref } from "react";
import { makeStyles, TextField } from "@material-ui/core";

import { MoneyInput } from "components";
import { EMPTY_VALUE_PLACEHOLDER } from "constants/index";

const useStyles = makeStyles(theme => ({
  moneyTextField: {
    width: "165px",
    "& .MuiInputBase-root": {
      fontSize: theme.typography.body2.fontSize,
      height: "32px",
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius,
      "&:hover": {
        borderColor: theme.palette.text.primary,
      },
      "&.Mui-focused": {
        borderColor: theme.palette.text.primary,
        borderWidth: "1px",
      },
    },
    "& .MuiInputBase-input": {
      padding: theme.spacing(0.5, 1),
      textAlign: "right",
    },
    "& .MuiInput-underline:before": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none",
    },
  },
}));

interface IrrMoneyInputProps {
  value: string | null;
  onChange: (value: string) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLDivElement>) => void;
  onBlur?: () => void;
  inputRef?: Ref<HTMLInputElement>;
  name?: string;
  placeholder?: string;
}

const IrrMoneyInput: FC<IrrMoneyInputProps> = ({
  value,
  onChange,
  onKeyDown,
  onBlur,
  inputRef,
  name,
  placeholder = EMPTY_VALUE_PLACEHOLDER,
}) => {
  const classes = useStyles();

  const handleFocus = () => {
    if (!value) {
      onChange("0");
    }
  };

  return (
    <TextField
      name={name}
      value={value || ""}
      onChange={e => onChange(e.target.value)}
      onFocus={handleFocus}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      InputProps={{
        inputComponent: MoneyInput,
      }}
      size="small"
      className={classes.moneyTextField}
      inputRef={inputRef}
    />
  );
};

export default IrrMoneyInput;
